import React from 'react';
import { Toggle } from '@carbon/react';

export default function ToggleControl({...rest}) {
  return (
    <Toggle labelText="" labelA="" labelB="" {...rest} />
  );
}
